import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTermsDelete = {
    path: "/terms/:id",
    method: RouteHttpVerb.DELETE
};
export { locationRestTermsDelete };
